/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CalculatePurchaseOrderValueView } from '../model/calculatePurchaseOrderValueView';
import { GetPurchaseOrderDetailView } from '../model/getPurchaseOrderDetailView';
import { HttpError } from '../model/httpError';
import { PurchaseOrderDetailInsert } from '../model/purchaseOrderDetailInsert';
import { PurchaseOrderDetailUpdate } from '../model/purchaseOrderDetailUpdate';
import { PurchaseOrderDetailView } from '../model/purchaseOrderDetailView';
import { SearchPurchaseOrderDetailView } from '../model/searchPurchaseOrderDetailView';
import { UnitType } from '../model/unitType';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PurchaseOrderDetailsService {

    protected basePath = 'https://develop-sysnet-api.hlcloud.com.au';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Delete a PurchaseOrderDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_delete_purchaseorderdetails
     * @param id Used to identify a specific record by its user specific unique external key
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purchaseOrderDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public purchaseOrderDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public purchaseOrderDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public purchaseOrderDetailsByExternalKeyIdDelete(id: string, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling purchaseOrderDetailsByExternalKeyIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/PurchaseOrderDetails/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a PurchaseOrderDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_purchaseorderdetails
     * @param id Used to identify a specific record by its user specific unique external key
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates FKExternalKeys   - **PurchaseOrderHeaderIdFKObject:** purchaseOrderHeaderId, externalKeys  - **StockIdFKObject:** stockId, externalKeys  - **SupplierInventoryCodeIdFKObject:** supplierInventoryCodeId, externalKeys  - **FactorIdFKObject:** factorId, externalKeys               
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purchaseOrderDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'body', reportProgress?: boolean): Observable<GetPurchaseOrderDetailView>;
    public purchaseOrderDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetPurchaseOrderDetailView>>;
    public purchaseOrderDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetPurchaseOrderDetailView>>;
    public purchaseOrderDetailsByExternalKeyIdGet(id: string, ridChain?: string, view?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling purchaseOrderDetailsByExternalKeyIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetPurchaseOrderDetailView>('get',`${this.basePath}/PurchaseOrderDetails/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a PurchaseOrderDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_purchaseorderdetails
     * @param id Used to identify a specific record by its user specific unique external key
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purchaseOrderDetailsByExternalKeyIdPut(id: string, body?: PurchaseOrderDetailUpdate, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PurchaseOrderDetailView>>;
    public purchaseOrderDetailsByExternalKeyIdPut(id: string, body?: PurchaseOrderDetailUpdate, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PurchaseOrderDetailView>>>;
    public purchaseOrderDetailsByExternalKeyIdPut(id: string, body?: PurchaseOrderDetailUpdate, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PurchaseOrderDetailView>>>;
    public purchaseOrderDetailsByExternalKeyIdPut(id: string, body?: PurchaseOrderDetailUpdate, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling purchaseOrderDetailsByExternalKeyIdPut.');
        }



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<PurchaseOrderDetailView>>('put',`${this.basePath}/PurchaseOrderDetails/byExternalKey/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Calculates a number of fields required based upon the unit type selected.
     * @param supplierId 
     * @param stockId 
     * @param locationId 
     * @param unitQtyToOrder 
     * @param unitType 
     * @param factorId 
     * @param supplierInventoryCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purchaseOrderDetailsCalculateValuesGet(supplierId: number, stockId: number, locationId: number, unitQtyToOrder: number, unitType: UnitType, factorId?: number, supplierInventoryCode?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CalculatePurchaseOrderValueView>>;
    public purchaseOrderDetailsCalculateValuesGet(supplierId: number, stockId: number, locationId: number, unitQtyToOrder: number, unitType: UnitType, factorId?: number, supplierInventoryCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CalculatePurchaseOrderValueView>>>;
    public purchaseOrderDetailsCalculateValuesGet(supplierId: number, stockId: number, locationId: number, unitQtyToOrder: number, unitType: UnitType, factorId?: number, supplierInventoryCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CalculatePurchaseOrderValueView>>>;
    public purchaseOrderDetailsCalculateValuesGet(supplierId: number, stockId: number, locationId: number, unitQtyToOrder: number, unitType: UnitType, factorId?: number, supplierInventoryCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (supplierId === null || supplierId === undefined) {
            throw new Error('Required parameter supplierId was null or undefined when calling purchaseOrderDetailsCalculateValuesGet.');
        }

        if (stockId === null || stockId === undefined) {
            throw new Error('Required parameter stockId was null or undefined when calling purchaseOrderDetailsCalculateValuesGet.');
        }

        if (locationId === null || locationId === undefined) {
            throw new Error('Required parameter locationId was null or undefined when calling purchaseOrderDetailsCalculateValuesGet.');
        }

        if (unitQtyToOrder === null || unitQtyToOrder === undefined) {
            throw new Error('Required parameter unitQtyToOrder was null or undefined when calling purchaseOrderDetailsCalculateValuesGet.');
        }

        if (unitType === null || unitType === undefined) {
            throw new Error('Required parameter unitType was null or undefined when calling purchaseOrderDetailsCalculateValuesGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (supplierId !== undefined && supplierId !== null) {
            queryParameters = queryParameters.set('supplierId', <any>supplierId);
        }
        if (stockId !== undefined && stockId !== null) {
            queryParameters = queryParameters.set('stockId', <any>stockId);
        }
        if (locationId !== undefined && locationId !== null) {
            queryParameters = queryParameters.set('locationId', <any>locationId);
        }
        if (unitQtyToOrder !== undefined && unitQtyToOrder !== null) {
            queryParameters = queryParameters.set('unitQtyToOrder', <any>unitQtyToOrder);
        }
        if (unitType !== undefined && unitType !== null) {
            queryParameters = queryParameters.set('unitType', <any>unitType);
        }
        if (factorId !== undefined && factorId !== null) {
            queryParameters = queryParameters.set('factorId', <any>factorId);
        }
        if (supplierInventoryCode !== undefined && supplierInventoryCode !== null) {
            queryParameters = queryParameters.set('supplierInventoryCode', <any>supplierInventoryCode);
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/html'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<CalculatePurchaseOrderValueView>>('get',`${this.basePath}/purchaseOrderDetails/calculateValues`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Search for PurchaseOrderDetail objects&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_purchaseorderdetails
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates PurchaseOrderDetailList   - **SupplierInventoryCode:** supplierInventoryCode  - **Stock:** name, innersPerOuter, inners, outers, lastCost, expectedCostPerOuter  - **PurchaseOrderHeader:** locationId, processed  - **Factor:** divider  FKExternalKeys   - **PurchaseOrderHeaderIdFKObject:** purchaseOrderHeaderId, externalKeys  - **StockIdFKObject:** stockId, externalKeys  - **SupplierInventoryCodeIdFKObject:** supplierInventoryCodeId, externalKeys  - **FactorIdFKObject:** factorId, externalKeys               
     * @param group This parameter is used to group results.                         The fieldName can be any of the following: purchaseOrderHeaderId, stockId, supplierInventoryCodeId, factorId.                         The sort could either have - to sort by descending and + to sort by ascending. See groupQuery schema for more info.                         For grouping using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param groupSummary This parameter is used to summarise grouped results by aggregating the groups.                 The fieldName can be any of the following: purchaseOrderDetailId, purchaseOrderHeaderId, stockId, supplierInventoryCodeId, factorId, unitQtyToOrder, qtyToOrder, totalInnersToOrder, costPerOuter, totalCost, qtyInStock, qtyRequired, qtyOnOrder.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param totalSummary This parameter is used to summarise all grouped results by aggregating all the groups sub groups.                 The fieldName can be any of the following: purchaseOrderDetailId, purchaseOrderHeaderId, stockId, supplierInventoryCodeId, factorId, unitQtyToOrder, qtyToOrder, totalInnersToOrder, costPerOuter, totalCost, qtyInStock, qtyRequired, qtyOnOrder.                         The type could be count,min,max,sum,avg. See groupSummaryQuery schema for more info.
     * @param searchDistinct This parameter is used to get the distinct values for a field.                  Only the field specified will be returned in the results. This can be used with filtering functionality, sort and limit.                  However it cannot be used with group, groupSummary or totalSummary.
     * @param sort This parameter is used to change the sorting of results returned.                          The default sort is purchaseOrderDetailId ascending.                          Use any fieldNames comma separated in the sort.                          Use + for ascending - for descending                          eg +updateDateTime.                         - purchaseOrderDetailId would sort by updateDateTime ascending and then purchaseOrderDetailId descending.  For sorting using a nested field use &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested levels eg +Stock.name                         For sorting using a nested field use &lt;object&gt;.&lt;field&gt; to specify the nested levels eg +Stock.name
     * @param limit This limits the amount of results returned. This default limit Is set to 20. The maximum limit is 200.
     * @param offset This parameter is used to change the default offset from 0. Offset is the position in the dataset of a particular record. By specifying offset, you retrieve a subset of records starting with the offset value. Eg: If you have 100 records in your result set, and you want to retrieve records 50 to 80, you will need to use offset&#x3D;49 and limit &#x3D; 30.
     * @param search This does an &lt;b&gt;advanced&lt;/b&gt; search using a url encoded JSON object. &lt;br&gt;&lt;br&gt;  Most fields available in the return object can be searched using this methodology. &lt;br&gt;Example: search&#x3D;{ \&quot;status\&quot;: \&quot;active\&quot;} would search the status field for the value: &#x27;active&#x27;.&lt;br&gt;&lt;br&gt;  Searching is also possible using nested fields. Use the following syntax: &amp;lt;object&amp;gt;.&amp;lt;field&amp;gt; to specify the nested field.&lt;br&gt; Example: search&#x3D;{ \&quot;Stock.name\&quot;: \&quot;Best Beer\&quot; }&lt;br&gt;&lt;br&gt;  There are a couple of extra operators that can be used in the search. These are $or, $and, $not. &lt;br&gt; Example: search&#x3D;{ \&quot;$or\&quot;: [ { \&quot;status\&quot;: \&quot;bad\&quot; }, { \&quot;status\&quot;: \&quot;worse\&quot; } ] }. Searches for the statuses of &#x27;bad&#x27; or &#x27;worse&#x27;.&lt;br&gt; The $or, $and and $not operators can be nested.&lt;br&gt;&lt;br&gt;  If the name pair contains a fieldName it is possible for the value to be a sub-object containing any number of operators. The operators depend on the fieldType of the fieldName:&lt;br&gt;&lt;br&gt; &lt;b&gt;Date time Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $gt, $gte, $lt, $lte, $in&lt;br&gt; Example: search&#x3D;{ \&quot;startTime\&quot;: { \&quot;$gt\&quot;: \&quot;2 November 2021\&quot; } }&lt;br&gt;&lt;br&gt; &lt;b&gt;Number Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $gt, $gte, $lt, $lte, $between, $notBetween, $in, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;totalCount\&quot;: { \&quot;$gt\&quot;: 10 } } &lt;br&gt;&lt;br&gt; &lt;b&gt;String Allowed Operators&lt;/b&gt;: $eq, $ne, $is, $not, $or, $in, $like, $iLike, $notLike, $notILike, $notIn&lt;br&gt; Example: search&#x3D;{ \&quot;failReason\&quot;: { \&quot;$in\&quot;: [\&quot;Out of bounds\&quot;, \&quot;Out of time\&quot;] } }&lt;br&gt;&lt;br&gt;  These operators equate to Sequelize operators. See &lt;a href&#x3D;\&quot;https://sequelize.org/docs/v7/querying/operators\&quot;&gt;Operators | Sequelize&lt;/a&gt;
     * @param purchaseOrderDetailId The unique identifier of this record.&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the purchaseOrderDetailId field and returns all available results that match.   You can use &gt;10 to search for all purchaseOrderDetailIds greater than 10. You can use [1,2,3] to search for purchaseOrderDetailIds that match either 1, 2 or 3. You can use this parameter multiple times. eg purchaseOrderDetailId&#x3D;&gt;5&amp; purchaseOrderDetailId&#x3D;&lt;10 would search for all purchaseOrderDetailIds between 5 and 10.
     * @param purchaseOrderHeaderId A reference to the primary key in the PurchaseOrderHeaders Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the purchaseOrderHeaderId field and returns all available results that match.   You can use &gt;10 to search for all purchaseOrderHeaderIds greater than 10. You can use [1,2,3] to search for purchaseOrderHeaderIds that match either 1, 2 or 3. You can use this parameter multiple times. eg purchaseOrderHeaderId&#x3D;&gt;5&amp; purchaseOrderHeaderId&#x3D;&lt;10 would search for all purchaseOrderHeaderIds between 5 and 10.
     * @param stockId A reference to the primary key in the Stock Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the stockId field and returns all available results that match.   You can use &gt;10 to search for all stockIds greater than 10. You can use [1,2,3] to search for stockIds that match either 1, 2 or 3. You can use this parameter multiple times. eg stockId&#x3D;&gt;5&amp; stockId&#x3D;&lt;10 would search for all stockIds between 5 and 10.
     * @param supplierInventoryCodeId A reference to the primary key in the SupplierInventoryCodes Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the supplierInventoryCodeId field and returns all available results that match.   You can use &gt;10 to search for all supplierInventoryCodeIds greater than 10. You can use [1,2,3] to search for supplierInventoryCodeIds that match either 1, 2 or 3. You can use this parameter multiple times. eg supplierInventoryCodeId&#x3D;&gt;5&amp; supplierInventoryCodeId&#x3D;&lt;10 would search for all supplierInventoryCodeIds between 5 and 10.
     * @param unitType &lt;br&gt;This parameter searches for the unitType field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param factorId A reference to the primary key in the Factors Table&lt;br&gt;&lt;b&gt;integer:&lt;/b&gt; This parameter searches the factorId field and returns all available results that match.   You can use &gt;10 to search for all factorIds greater than 10. You can use [1,2,3] to search for factorIds that match either 1, 2 or 3. You can use this parameter multiple times. eg factorId&#x3D;&gt;5&amp; factorId&#x3D;&lt;10 would search for all factorIds between 5 and 10.
     * @param unitQtyToOrder &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the unitQtyToOrder field and returns all available results that match.   You can use &gt;10 to search for all unitQtyToOrders greater than 10. You can use [1,2,3] to search for unitQtyToOrders that match either 1, 2 or 3. You can use this parameter multiple times. eg unitQtyToOrder&#x3D;&gt;5&amp; unitQtyToOrder&#x3D;&lt;10 would search for all unitQtyToOrders between 5 and 10.
     * @param qtyToOrder &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the qtyToOrder field and returns all available results that match.   You can use &gt;10 to search for all qtyToOrders greater than 10. You can use [1,2,3] to search for qtyToOrders that match either 1, 2 or 3. You can use this parameter multiple times. eg qtyToOrder&#x3D;&gt;5&amp; qtyToOrder&#x3D;&lt;10 would search for all qtyToOrders between 5 and 10.
     * @param totalInnersToOrder &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the totalInnersToOrder field and returns all available results that match.   You can use &gt;10 to search for all totalInnersToOrders greater than 10. You can use [1,2,3] to search for totalInnersToOrders that match either 1, 2 or 3. You can use this parameter multiple times. eg totalInnersToOrder&#x3D;&gt;5&amp; totalInnersToOrder&#x3D;&lt;10 would search for all totalInnersToOrders between 5 and 10.
     * @param costPerOuter &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the costPerOuter field and returns all available results that match.   You can use &gt;10 to search for all costPerOuters greater than 10. You can use [1,2,3] to search for costPerOuters that match either 1, 2 or 3. You can use this parameter multiple times. eg costPerOuter&#x3D;&gt;5&amp; costPerOuter&#x3D;&lt;10 would search for all costPerOuters between 5 and 10.
     * @param totalCost &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the totalCost field and returns all available results that match.   You can use &gt;10 to search for all totalCosts greater than 10. You can use [1,2,3] to search for totalCosts that match either 1, 2 or 3. You can use this parameter multiple times. eg totalCost&#x3D;&gt;5&amp; totalCost&#x3D;&lt;10 would search for all totalCosts between 5 and 10.
     * @param lastUpdateByUserId The userId of the last person to modify this record.&lt;br&gt;This parameter searches for the lastUpdateByUserId field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param createDateTime The date and time this record was created.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the createDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all createDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for createDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg createDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; createDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all createDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param updateDateTime The last date and time this record was updated.&lt;br&gt;&lt;b&gt;string:&lt;/b&gt; This parameter searches the updateDateTime field and returns all available results that match.   You can use &gt;12 jan 2020 5:30:20 GMT+10:30 to search for all updateDateTimes greater than 12 jan 2020 5:30:20 GMT+10:30. You can use [1,2,3] to search for updateDateTimes that match either 1, 2 or 3. You can use this parameter multiple times. eg updateDateTime&#x3D;&gt;12 jan 2020 5:30:20 GMT+10:30&amp; updateDateTime&#x3D;&lt;12 jan 2020 5:30:20 GMT+10:30 would search for all updateDateTimes between 12 jan 2020 5:30:20 GMT+10:30 and 14 jan 2020 5:30:20 GMT+10:30.
     * @param qtyInStock &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the qtyInStock field and returns all available results that match.   You can use &gt;10 to search for all qtyInStocks greater than 10. You can use [1,2,3] to search for qtyInStocks that match either 1, 2 or 3. You can use this parameter multiple times. eg qtyInStock&#x3D;&gt;5&amp; qtyInStock&#x3D;&lt;10 would search for all qtyInStocks between 5 and 10.
     * @param qtyRequired &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the qtyRequired field and returns all available results that match.   You can use &gt;10 to search for all qtyRequireds greater than 10. You can use [1,2,3] to search for qtyRequireds that match either 1, 2 or 3. You can use this parameter multiple times. eg qtyRequired&#x3D;&gt;5&amp; qtyRequired&#x3D;&lt;10 would search for all qtyRequireds between 5 and 10.
     * @param qtyOnOrder &lt;br&gt;&lt;b&gt;number:&lt;/b&gt; This parameter searches the qtyOnOrder field and returns all available results that match.   You can use &gt;10 to search for all qtyOnOrders greater than 10. You can use [1,2,3] to search for qtyOnOrders that match either 1, 2 or 3. You can use this parameter multiple times. eg qtyOnOrder&#x3D;&gt;5&amp; qtyOnOrder&#x3D;&lt;10 would search for all qtyOnOrders between 5 and 10.
     * @param externalKey The unique external key set by the current user accessing the API&lt;br&gt;This parameter searches for the externalKey field and returns all available results that match. You can use this parameter multiple times and it will do an &#x27;AND&#x27; search. You can use * as a wildcard. You can use brackets and a comma to perform an ‘OR’ search e.g [a,b*] will search for ‘a’ OR a value starting with ‘b’.
     * @param organisationId Allows an api user to filter results by 1 or more organisationIds. To use multiple organisationIds: organisationId&#x3D;[org1,org2]
     * @param venueId Allows an api user to filter results by 1 or more venueIds. To use multiple organisationIds: venueId&#x3D;[venueId1,venueId2]
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purchaseOrderDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, purchaseOrderDetailId?: number, purchaseOrderHeaderId?: number, stockId?: number, supplierInventoryCodeId?: number, unitType?: string, factorId?: number, unitQtyToOrder?: string, qtyToOrder?: string, totalInnersToOrder?: string, costPerOuter?: string, totalCost?: string, lastUpdateByUserId?: string, createDateTime?: string, updateDateTime?: string, qtyInStock?: string, qtyRequired?: string, qtyOnOrder?: string, externalKey?: string, organisationId?: string, venueId?: string, observe?: 'body', reportProgress?: boolean): Observable<SearchPurchaseOrderDetailView>;
    public purchaseOrderDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, purchaseOrderDetailId?: number, purchaseOrderHeaderId?: number, stockId?: number, supplierInventoryCodeId?: number, unitType?: string, factorId?: number, unitQtyToOrder?: string, qtyToOrder?: string, totalInnersToOrder?: string, costPerOuter?: string, totalCost?: string, lastUpdateByUserId?: string, createDateTime?: string, updateDateTime?: string, qtyInStock?: string, qtyRequired?: string, qtyOnOrder?: string, externalKey?: string, organisationId?: string, venueId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchPurchaseOrderDetailView>>;
    public purchaseOrderDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, purchaseOrderDetailId?: number, purchaseOrderHeaderId?: number, stockId?: number, supplierInventoryCodeId?: number, unitType?: string, factorId?: number, unitQtyToOrder?: string, qtyToOrder?: string, totalInnersToOrder?: string, costPerOuter?: string, totalCost?: string, lastUpdateByUserId?: string, createDateTime?: string, updateDateTime?: string, qtyInStock?: string, qtyRequired?: string, qtyOnOrder?: string, externalKey?: string, organisationId?: string, venueId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchPurchaseOrderDetailView>>;
    public purchaseOrderDetailsGet(ridChain?: string, view?: string, group?: string, groupSummary?: string, totalSummary?: string, searchDistinct?: string, sort?: string, limit?: number, offset?: number, search?: string, purchaseOrderDetailId?: number, purchaseOrderHeaderId?: number, stockId?: number, supplierInventoryCodeId?: number, unitType?: string, factorId?: number, unitQtyToOrder?: string, qtyToOrder?: string, totalInnersToOrder?: string, costPerOuter?: string, totalCost?: string, lastUpdateByUserId?: string, createDateTime?: string, updateDateTime?: string, qtyInStock?: string, qtyRequired?: string, qtyOnOrder?: string, externalKey?: string, organisationId?: string, venueId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }
        if (group !== undefined && group !== null) {
            queryParameters = queryParameters.set('group', <any>group);
        }
        if (groupSummary !== undefined && groupSummary !== null) {
            queryParameters = queryParameters.set('groupSummary', <any>groupSummary);
        }
        if (totalSummary !== undefined && totalSummary !== null) {
            queryParameters = queryParameters.set('totalSummary', <any>totalSummary);
        }
        if (searchDistinct !== undefined && searchDistinct !== null) {
            queryParameters = queryParameters.set('searchDistinct', <any>searchDistinct);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (purchaseOrderDetailId !== undefined && purchaseOrderDetailId !== null) {
            queryParameters = queryParameters.set('purchaseOrderDetailId', <any>purchaseOrderDetailId);
        }
        if (purchaseOrderHeaderId !== undefined && purchaseOrderHeaderId !== null) {
            queryParameters = queryParameters.set('purchaseOrderHeaderId', <any>purchaseOrderHeaderId);
        }
        if (stockId !== undefined && stockId !== null) {
            queryParameters = queryParameters.set('stockId', <any>stockId);
        }
        if (supplierInventoryCodeId !== undefined && supplierInventoryCodeId !== null) {
            queryParameters = queryParameters.set('supplierInventoryCodeId', <any>supplierInventoryCodeId);
        }
        if (unitType !== undefined && unitType !== null) {
            queryParameters = queryParameters.set('unitType', <any>unitType);
        }
        if (factorId !== undefined && factorId !== null) {
            queryParameters = queryParameters.set('factorId', <any>factorId);
        }
        if (unitQtyToOrder !== undefined && unitQtyToOrder !== null) {
            queryParameters = queryParameters.set('unitQtyToOrder', <any>unitQtyToOrder);
        }
        if (qtyToOrder !== undefined && qtyToOrder !== null) {
            queryParameters = queryParameters.set('qtyToOrder', <any>qtyToOrder);
        }
        if (totalInnersToOrder !== undefined && totalInnersToOrder !== null) {
            queryParameters = queryParameters.set('totalInnersToOrder', <any>totalInnersToOrder);
        }
        if (costPerOuter !== undefined && costPerOuter !== null) {
            queryParameters = queryParameters.set('costPerOuter', <any>costPerOuter);
        }
        if (totalCost !== undefined && totalCost !== null) {
            queryParameters = queryParameters.set('totalCost', <any>totalCost);
        }
        if (lastUpdateByUserId !== undefined && lastUpdateByUserId !== null) {
            queryParameters = queryParameters.set('lastUpdateByUserId', <any>lastUpdateByUserId);
        }
        if (createDateTime !== undefined && createDateTime !== null) {
            queryParameters = queryParameters.set('createDateTime', <any>createDateTime);
        }
        if (updateDateTime !== undefined && updateDateTime !== null) {
            queryParameters = queryParameters.set('updateDateTime', <any>updateDateTime);
        }
        if (qtyInStock !== undefined && qtyInStock !== null) {
            queryParameters = queryParameters.set('qtyInStock', <any>qtyInStock);
        }
        if (qtyRequired !== undefined && qtyRequired !== null) {
            queryParameters = queryParameters.set('qtyRequired', <any>qtyRequired);
        }
        if (qtyOnOrder !== undefined && qtyOnOrder !== null) {
            queryParameters = queryParameters.set('qtyOnOrder', <any>qtyOnOrder);
        }
        if (externalKey !== undefined && externalKey !== null) {
            queryParameters = queryParameters.set('externalKey', <any>externalKey);
        }
        if (organisationId !== undefined && organisationId !== null) {
            queryParameters = queryParameters.set('organisationId', <any>organisationId);
        }
        if (venueId !== undefined && venueId !== null) {
            queryParameters = queryParameters.set('venueId', <any>venueId);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SearchPurchaseOrderDetailView>('get',`${this.basePath}/PurchaseOrderDetails/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Delete a PurchaseOrderDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_delete_purchaseorderdetails
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purchaseOrderDetailsIdDelete(id: number, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public purchaseOrderDetailsIdDelete(id: number, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public purchaseOrderDetailsIdDelete(id: number, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public purchaseOrderDetailsIdDelete(id: number, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling purchaseOrderDetailsIdDelete.');
        }


        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/PurchaseOrderDetails/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Gets a PurchaseOrderDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_get_purchaseorderdetails
     * @param id Used to identify a specific record by its unique ID
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param view  The view is the list of fields you want returned.  ### View Templates FKExternalKeys   - **PurchaseOrderHeaderIdFKObject:** purchaseOrderHeaderId, externalKeys  - **StockIdFKObject:** stockId, externalKeys  - **SupplierInventoryCodeIdFKObject:** supplierInventoryCodeId, externalKeys  - **FactorIdFKObject:** factorId, externalKeys               
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purchaseOrderDetailsIdGet(id: number, ridChain?: string, view?: string, observe?: 'body', reportProgress?: boolean): Observable<GetPurchaseOrderDetailView>;
    public purchaseOrderDetailsIdGet(id: number, ridChain?: string, view?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetPurchaseOrderDetailView>>;
    public purchaseOrderDetailsIdGet(id: number, ridChain?: string, view?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetPurchaseOrderDetailView>>;
    public purchaseOrderDetailsIdGet(id: number, ridChain?: string, view?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling purchaseOrderDetailsIdGet.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (view !== undefined && view !== null) {
            queryParameters = queryParameters.set('view', <any>view);
        }

        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetPurchaseOrderDetailView>('get',`${this.basePath}/PurchaseOrderDetails/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Update a PurchaseOrderDetail object&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_update_purchaseorderdetails
     * @param id Used to identify a specific record by its unique ID
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purchaseOrderDetailsIdPut(id: number, body?: PurchaseOrderDetailUpdate, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<PurchaseOrderDetailView>>;
    public purchaseOrderDetailsIdPut(id: number, body?: PurchaseOrderDetailUpdate, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PurchaseOrderDetailView>>>;
    public purchaseOrderDetailsIdPut(id: number, body?: PurchaseOrderDetailUpdate, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PurchaseOrderDetailView>>>;
    public purchaseOrderDetailsIdPut(id: number, body?: PurchaseOrderDetailUpdate, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling purchaseOrderDetailsIdPut.');
        }



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<PurchaseOrderDetailView>>('put',`${this.basePath}/PurchaseOrderDetails/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Creates a new PurchaseOrderDetail&lt;br&gt;&lt;br&gt;You will need to have the following data accesses assigned to your user to use this route: sc_insert_purchaseorderdetails
     * @param body 
     * @param ridChain The rid_chain is used to track the current users session. It should be a unique value that identifies a users particular session in a particular device. When events are received through H&amp;L websocket events, the current user&#x27;s session can be identified with this value. As such this value can help you determine which device a user was on when they made a request on this API.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public purchaseOrderDetailsPost(body?: PurchaseOrderDetailInsert, ridChain?: string, observe?: 'body', reportProgress?: boolean): Observable<PurchaseOrderDetailView>;
    public purchaseOrderDetailsPost(body?: PurchaseOrderDetailInsert, ridChain?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PurchaseOrderDetailView>>;
    public purchaseOrderDetailsPost(body?: PurchaseOrderDetailInsert, ridChain?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PurchaseOrderDetailView>>;
    public purchaseOrderDetailsPost(body?: PurchaseOrderDetailInsert, ridChain?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (ridChain !== undefined && ridChain !== null) {
            headers = headers.set('rid_chain', String(ridChain));
        }

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<PurchaseOrderDetailView>('post',`${this.basePath}/PurchaseOrderDetails/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
